import {
  UserPermission,
  UserPermissions,
} from "../plugins/Cruxtify/UserPermission";

import { ErCrudModel } from "./ErCrudModel";

export class SubscriptionItem extends ErCrudModel {
  protected static _typeLabel = "SubscriptionItem";
  protected static _typeLabelPlural = "Subscription Items";
  protected static asProperty = "subscription-item";
  public static api = {
    path: "subscription-items",
    fullCache: true,
  };
  protected static routeBase = "subscription-items";
  protected static userPermissions = new UserPermissions(UserPermission.Read);

  // Ownership is one hop away, on the parent subscription -- there is no
  // local `user` field, so the CrudModel default of `["user"]` made
  // getUserId() log a warn + an error for every row hydrated on the admin
  // user page. `[]` is the same declaration ExpertMatch and SubmissionEvent
  // make for the same reason (asana-1388).
  protected userIdField = [];

  protected static propertyDefinitions = [
    {
      type: "NumberProperty",
      opts: {
        name: "id",
        label: "ID",
        userPermissions: UserPermission.Hidden,
      },
    },
    {
      type: "DateTimeProperty",
      opts: {
        name: "created_at",
        label: "Entry Created At",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
    {
      type: "DateTimeProperty",
      opts: {
        name: "updated_at",
        label: "Entry Updated At",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
    {
      type: "StringProperty",
      opts: {
        name: "type",
        label: "Type",
      },
    },
    {
      type: "StringProperty",
      opts: {
        name: "stripe_id",
        label: "Stripe ID",
      },
    },
    {
      type: "StringProperty",
      opts: {
        name: "stripe_product",
        label: "Stripe Product",
      },
    },
    {
      type: "NumberProperty",
      opts: {
        name: "stripe_price",
        label: "Stripe Price",
      },
    },
    {
      type: "NumberProperty",
      opts: {
        name: "quantity",
        label: "Quantity",
      },
    },
    {
      type: "RelationshipProperty",
      opts: {
        name: "subscription",
        label: "Subscription",
        relatedModel: "Subscription",
        foreignProperty: "subscription_items",
      },
    },
  ];

  protected static fieldDefinitions = [
    { type: "NumberField", opts: { property: "id" } },
    {
      type: "DateTimeField",
      opts: { property: "created_at" },
    },
    { type: "DateTimeField", opts: { property: "updated_at" } },
    {
      type: "StringField",
      opts: { property: "stripe_id", isPrimaryLabelField: true },
    },
    {
      type: "StringField",
      opts: { property: "stripe_product" },
    },
    {
      type: "NumberField",
      opts: { property: "stripe_price" },
    },
    {
      type: "NumberField",
      opts: { property: "quantity" },
    },
    {
      type: "RelationshipField",
      opts: {
        property: "subscription",
      },
    },
  ];

  protected static collectionLayoutDefinitions = [
    {
      id: "table",
      columnFields: ["stripe_product", "stripe_price", "quantity"],
      enableDynamicFilters: false,
      useModal: true,
      enableSearch: false,
      defaultSort: [
        {
          field: "strip_product",
          order: "asc",
        },
      ],
    },
  ];
}
